// Instead of applying dozens and dozens of various elements to the body,
// create one container for them all, and for the time being, it works fine.
class PopoverContainer {
  static tooltip(id) {
    return new this(id, 'var(--layer-tooltip)');
  }

  static dropdown(id) {
    return new this(id, 'var(--layer-popover)');
  }

  constructor(id, z) {
    this.container = null;
    this.id = id;
    this.z = z;
  }

  add(element) {
    if (!this.container) {
      this.container = this.#createContainer();
      document.body.appendChild(this.container);
    }

    this.container.appendChild(element);
  }

  has(element) {
    return this.container && this.container.contains(element);
  }

  #createContainer() {
    const container = document.createElement('div');
    container.id = this.id;
    container.style.zIndex = this.z;
    return container;
  }
}

export default PopoverContainer;
